import {FieldErrors, useFormContext} from "react-hook-form";
import {FiX} from "react-icons/fi";

import Button from "@/components/button/Button.tsx";
import {ContactsSelectField} from "@/components/form/fields/ContactsSelectField/ContactsSelectField.tsx";
import {NumberInputField} from "@/components/form/fields/NumberInputField.tsx";
import {SelectField} from "@/components/form/fields/SelectField/SelectField.tsx";
import {FormSubtext} from "@/components/formSubtext/FormSubtext.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {Input} from "@/components/input/Input.tsx";
import {MaintenanceScheduleFormData} from "@/pages/maintenance/maintenance-create/CreateEditMaintenanceScheduleForm.types.ts";
import {NotificationFormRow} from "@/pages/maintenance/maintenance-create/tabs/notifications/MaintenanceScheduleNotificationsTab.types.ts";
import {
  EVENT_OPTIONS,
  TIMING_UNIT_OPTIONS,
} from "@/pages/maintenance/maintenance-create/tabs/notifications/NotificationRow.types.ts";

import styles from "./MaintenanceScheduleNotificationsTab.module.scss";

interface NotificationRowProps {
  index: number;
  onRemove: () => void;
}

export const NotificationRow = ({index, onRemove}: NotificationRowProps) => {
  const {
    register,
    formState: {errors},
  } = useFormContext<MaintenanceScheduleFormData>();
  const prefix = `notifications.${index}` as const;

  const rowErrors = errors.notifications?.[index] as FieldErrors<NotificationFormRow> | undefined;
  const errorMessage = rowErrors?.timing_amount?.message;
  const isInvalid = !!errorMessage;

  return (
    <>
      <NumberInputField
        name={`${prefix}.timing_amount`}
        label={null}
        hideErrorMessage
        invalid={isInvalid}
        input={<Input type="number" min={0} {...register(`${prefix}.timing_amount`, {valueAsNumber: true})} />}
      />
      <SelectField
        name={`${prefix}.timing_unit`}
        options={TIMING_UNIT_OPTIONS}
        label={null}
        placeholder="unit..."
        invalid={isInvalid}
      />
      <SelectField
        name={`${prefix}.event`}
        options={EVENT_OPTIONS}
        label={null}
        placeholder="Select event..."
        invalid={isInvalid}
      />
      <ContactsSelectField name={`${prefix}.contact_group_ids`} label={null} invalid={isInvalid} />
      <div>
        <Button variant="ghost" size="small" className="p-0" onClick={onRemove} aria-label="Remove notification">
          <Icon icon={FiX} />
        </Button>
      </div>
      {errorMessage && (
        <div className={styles.errorRow}>
          <FormSubtext error={errorMessage} />
        </div>
      )}
    </>
  );
};
